// @flow

import { type SearchSketchOrder } from "../typeDefinitions/searchSketchOrder";
import { type SketchOrder } from "../typeDefinitions/sketchOrder";

export const mapSearchSketchOrderToSketchOrder = (searchSketchOrder: SearchSketchOrder): SketchOrder => {
    return {
        id: parseInt(searchSketchOrder.id, 10), // cast to a number,
        projectName: searchSketchOrder.projectName,
        completedDate: searchSketchOrder.completedDate,
        requestedDate: searchSketchOrder.requestedDate,
        updatedAt: searchSketchOrder.updatedAt,
        address: searchSketchOrder.address,
        city: searchSketchOrder.city,
        region: searchSketchOrder.region,
        postCode: searchSketchOrder.postCode,
        country: searchSketchOrder.country,
        sketchOrderStatus: searchSketchOrder.sketchOrderStatus,
        cost: searchSketchOrder.cost,
        projectId: searchSketchOrder.projectId,
        organization: {
            id: searchSketchOrder.organizationId,
            name: searchSketchOrder.organizationName
        },
        requester: {
            userId: searchSketchOrder.requesterUserId,
            userName: searchSketchOrder.requesterUserName,
        },
        owner: {
            userId: searchSketchOrder.ownerUserId,
            userName: searchSketchOrder.ownerUserName
        },
    };
};